export const formatNumberToUnit = (number, unit = '') => {
	if (number === undefined) {
		return number;
	}

	return (
		number
			.toFixed(2)
			.replace('.', ',')
			.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + unit
	);
};
